"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var credit_card_type_1 = __importDefault(require("credit-card-type"));
var format_string_by_pattern_1 = __importDefault(require("format-string-by-pattern"));
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var InputText_1 = __importDefault(require("../../../InputText"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var Cards = function (_a) {
    var _b, _c;
    var method = _a.method;
    var t = (0, next_intl_1.useTranslations)('translation');
    var fields = method.fields.filter(function (f) { return f.name !== 'withdrawal.amount'; });
    var config = (0, swr_hooks_1.useConfig)();
    var countries = (0, swr_hooks_1.useCountriesOptions)();
    var formState = (0, react_final_form_1.useFormState)();
    var getField = function (field) { return fields.find(function (f) { return f.name === field; }); };
    var cardNumber = getField('customer.card_number');
    var expirationDate = getField('customer.expiration_date');
    var firstName = getField('customer.first_name');
    var lastName = getField('customer.last_name');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.rowPart },
            cardNumber && react_1.default.createElement(CardField, { field: cardNumber, mask: masks.card }),
            expirationDate && (react_1.default.createElement(InputField, { field: expirationDate, mask: masks.expDate }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldsContainer },
            firstName && react_1.default.createElement(InputField, { field: firstName }),
            lastName && react_1.default.createElement(InputField, { field: lastName }), (_c = (_b = config === null || config === void 0 ? void 0 : config.additionalWithdrawalFields) === null || _b === void 0 ? void 0 : _b['banking-card']) === null || _c === void 0 ? void 0 :
            _c.map(function (field, idx) {
                if (field === null || field === void 0 ? void 0 : field.hidden)
                    return null;
                if (field.type === 'phone')
                    return (react_1.default.createElement(react_final_form_1.Field, { name: "phone", key: "withdrawalField_".concat(field === null || field === void 0 ? void 0 : field.type, "_").concat(idx), render: function (_a) {
                            var _b, _c, _d;
                            var input = _a.input, meta = _a.meta;
                            return (react_1.default.createElement("div", { style: { gridColumn: '1 / -1' } },
                                react_1.default.createElement(ui_components_1.PhoneInput, __assign({}, input, { country: (_d = (_c = (_b = formState === null || formState === void 0 ? void 0 : formState.values) === null || _b === void 0 ? void 0 : _b['country']) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.toLowerCase(), placeholder: t('phone'), labelText: t('phone'), countryCodeEditable: true, helperButton: meta.error && meta.touched && { type: 'error' }, tooltip: react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                            __html: t.raw('lockPersonalData'),
                                        } }) })),
                                meta.error && meta.touched && (react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper },
                                    react_1.default.createElement(ui_components_1.ErrorText, null, meta.error)))));
                        } }));
                if (field.type === 'country')
                    return (react_1.default.createElement(react_final_form_1.Field, { name: "country", key: "withdrawalField_".concat(field === null || field === void 0 ? void 0 : field.type, "_").concat(idx), render: function (_a) {
                            var _b;
                            var input = _a.input, meta = _a.meta;
                            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                react_1.default.createElement(ui_components_1.InputSelect, __assign({}, input, { labelText: t('country'), options: countries, placeholder: t('selectCountry'), hasError: meta.error && meta.touched, isDisabled: false, helperButton: meta.error && meta.touched && { type: 'error' } })),
                                meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, (_b = meta.error) === null || _b === void 0 ? void 0 : _b.value))));
                        } }));
                return (react_1.default.createElement(InputField, { key: "withdrawalField_".concat(field === null || field === void 0 ? void 0 : field.type, "_").concat(idx), field: field }));
            }))));
};
var masks = {
    card: '0000 0000 0000 0000',
    expDate: 'MM/YY',
};
var cardImages = [
    'visa',
    'mastercard',
    'unionpay',
    'american-express',
    'maestro',
    'mir',
    'jcb',
];
var CardField = function (_a) {
    var field = _a.field, _b = _a.mask, mask = _b === void 0 ? '' : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _c = (0, react_1.useState)(null), cardType = _c[0], setCardType = _c[1];
    var handleCardOnChange = function (e, onChange) {
        // For prevent using string in number field
        if (Number.isNaN(Number(e.target.value.replaceAll(' ', '')))) {
            return;
        }
        var type = (0, credit_card_type_1.default)(e.target.value)[0];
        if (e.target.value) {
            setCardType(type);
        }
        else {
            setCardType(null);
        }
        onChange(e);
    };
    return (react_1.default.createElement(react_final_form_1.Field, { name: field.type, key: "field_name_".concat(field.type), parse: mask ? (0, format_string_by_pattern_1.default)(mask) : function (v) { return v; } }, function (_a) {
        var input = _a.input, meta = _a.meta;
        return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.inputWrapper, " ").concat(styles_module_scss_1.default.cardField) },
            input.value && cardType && cardImages.includes(cardType.type) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.cardType },
                react_1.default.createElement("img", { src: "/img/payments/methods/".concat(cardType.type, ".svg") }))),
            react_1.default.createElement(InputText_1.default, __assign({ labelText: t("".concat(field.name, ".title")), id: field.type, placeholder: t("".concat(field.name, ".placeholder")), type: field.type, helpertext: meta.error && meta.touched
                    ? { status: 'error', text: meta.error }
                    : undefined }, input, { onChange: function (e) { return handleCardOnChange(e, input.onChange); } }))));
    }));
};
var InputField = function (_a) {
    var field = _a.field, _b = _a.mask, mask = _b === void 0 ? '' : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(react_final_form_1.Field, { name: field.type, key: "field_name_".concat(field.type), parse: mask ? (0, format_string_by_pattern_1.default)(mask) : function (v) { return v; } }, function (_a) {
        var input = _a.input, meta = _a.meta;
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
            react_1.default.createElement(InputText_1.default, __assign({ labelText: t("".concat(field.name, ".title")), id: field.type, placeholder: t("".concat(field.name, ".placeholder")), type: field.type, helpertext: meta.error && meta.touched
                    ? { status: 'error', text: meta.error }
                    : undefined }, input))));
    }));
};
exports.default = Cards;
